import axios from 'axios';

class AuthUtil {
    static getToken() {
        return localStorage.getItem('token');
    }

    static isTokenValid() {
        const token = this.getToken();
        return !!token;
    }

    static handleLogout() {
        localStorage.clear();
        window.location.replace('/login')
    }

    static async putRequest(endpoint,data) {
        try {
            const response = await axios.put(endpoint,data, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                    'Content-Type': 'application/json'
                }
            });
            return response;
        } catch (error) {
            this.checkAuthError(error);
            throw error;
        }
    }

    static async getRequest(endpoint) {
        try {
            const response = await axios.get(endpoint, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`
                }
            });
            return response;
        } catch (error) {
            this.checkAuthError(error);
            throw error;
        }
    }

    static async postUploadRequest(endpoint, data, onProgress) {
        try {
            const response = await axios.post(endpoint, data, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                    'Content-Type': 'application/json'

                },
                onUploadProgress: (progressEvent) => {
                    if (onProgress && progressEvent.total) {
                        const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        onProgress(progress);
                    }
                }
            });
            return response;
        } catch (error) {
            this.checkAuthError(error);
            throw error;
        }
    }

    static async postMultipartRequest(endpoint, formData) {
        try {
            const response = await axios.post(endpoint, formData, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`
                }
            });
            return response;
        } catch (error) {
            this.checkAuthError(error);
            throw error;
        }
    }

    static async postRequest(endpoint, data) {
        try {
            const response = await axios.post(endpoint, data, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                    'Content-Type': 'application/json'
                }
            });
            return response;
        } catch (error) {
            this.checkAuthError(error);
            throw error;
        }
    }

    static checkAuthError(error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            this.handleLogout();
        }
    }
}

export default AuthUtil;
